import * as React from 'react';
import { useContext } from 'react';

import type { CarouselCollection } from 'bundles/collections-carousel/types/CarouselCollection';

export type ConsumerPathwayRoleRelatedDegreesContextType =
  | {
      relatedDegrees: CarouselCollection | null;
      relatedDegreesLoading: boolean;
    }
  | null
  | undefined;

const ConsumerPathwayRoleRelatedDegreeCollectionContext =
  React.createContext<ConsumerPathwayRoleRelatedDegreesContextType>(undefined);

export const useRoleRelatedDegrees = () => {
  return useContext(ConsumerPathwayRoleRelatedDegreeCollectionContext);
};

export default ConsumerPathwayRoleRelatedDegreeCollectionContext;
